import PortalIdParser from 'PortalIdParser';
import { isListMembershipEventName } from 'automation-ui-enrollment/utils/listMembershipUtils';
import { ONCE } from 'automation-ui-enrollment/constants/scheduledEnrollment/ScheduleCadence';
import EnrollmentSchedule from 'automation-ui-enrollment/records/EnrollmentSchedule';
import { applyEventTriggersToFlow, applyListTriggersToFlow, applyScheduledTriggersToFlow, applyManualTriggersToFlow, removeManualTriggersFromFlow } from 'automation-ui-canvas/create/utils/applyTriggers';
export function applyTriggerOptionToFlow(triggerOption, draftFlow) {
  if (triggerOption.type === 'LIST') {
    applyListTriggersToFlow({
      filterBranches: [],
      filterBranchOperator: 'OR',
      filterBranchType: 'OR',
      filters: []
    }, draftFlow);
  } else if (triggerOption.type === 'EVENT') {
    if (isListMembershipEventName(triggerOption.fullyQualifiedName)) {
      var _triggerOption$filter;
      applyEventTriggersToFlow({
        filterBranches: [{
          filterBranches: [],
          filterBranchOperator: 'AND',
          filterBranchType: 'AND',
          filters: (_triggerOption$filter = triggerOption.filters) !== null && _triggerOption$filter !== void 0 ? _triggerOption$filter : [{
            filterType: 'CONSTANT',
            shouldAccept: true
          }]
        }],
        filterBranchOperator: 'OR',
        filterBranchType: 'OR',
        filters: []
      }, draftFlow);
    } else {
      var _triggerOption$filter2;
      applyEventTriggersToFlow({
        filterBranches: [{
          filterBranches: [{
            eventTypeId: triggerOption.value,
            filterBranches: [],
            filterBranchOperator: 'AND',
            filterBranchType: 'UNIFIED_EVENTS',
            filters: (_triggerOption$filter2 = triggerOption.filters) !== null && _triggerOption$filter2 !== void 0 ? _triggerOption$filter2 : [{
              filterType: 'CONSTANT',
              shouldAccept: true
            }],
            coalescingRefineBy: {
              type: 'SetOccurrencesRefineBy',
              setType: 'ANY'
            }
          }],
          filterBranchOperator: 'AND',
          filterBranchType: 'AND',
          filters: []
        }],
        filterBranchOperator: 'OR',
        filterBranchType: 'OR',
        filters: []
      }, draftFlow);
    }
  } else if (triggerOption.type === 'SCHEDULED') {
    applyScheduledTriggersToFlow(EnrollmentSchedule.getDefaultScheduleForPortal(PortalIdParser.get()).setCadence(ONCE), draftFlow);
  } else if (triggerOption.type === 'MANUAL') {
    applyManualTriggersToFlow(draftFlow);
  }
}
export function removeTriggerOptionFromFlow(triggerOption, draftFlow) {
  if (triggerOption.type === 'LIST') {
    return applyListTriggersToFlow(null, draftFlow);
  } else if (triggerOption.type === 'EVENT') {
    return applyEventTriggersToFlow(null, draftFlow);
  } else if (triggerOption.type === 'SCHEDULED') {
    return applyScheduledTriggersToFlow(null, draftFlow);
  } else if (triggerOption.type === 'MANUAL') {
    return removeManualTriggersFromFlow(draftFlow);
  }
}